<div #tabList class="tabs" [class.animated]="animated()" role="group" *transloco="let t">
	<!-- The lit pill, behind the tabs: it slides to the chosen one. -->
	<span class="thumb" aria-hidden="true"></span>

	@for (tab of tabs; track tab.scope) {
		<button
			#tabButton
			type="button"
			class="tab"
			[class.active]="tab.scope === scope()"
			[attr.aria-pressed]="tab.scope === scope()"
			(click)="select(tab.scope)"
		>
			<base-icon class="tab-icon" [icon]="tab.icon" />
			<span class="tab-label">{{ t(tab.labelKey) }}</span>
		</button>
	}
</div>
